module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Railway monitoring","stats":{"monitoringSections":"Sections","totalSections":"Total sensors","totalLength":"Total length"},"sectionsBtn":"SECTIONS"},"it":{"title":"Monitoraggio della ferrovia","stats":{"monitoringSections":"Sezioni di monitoraggio","totalSections":"Sensori totali","totalLength":"Lunghezza totale"},"sectionsBtn":"SEZIONI"}}')
  delete Component.options._Ctor
}
